module.exports = __webpack_public_path__ + "static/media/sk.fb4e79cf.webp";